import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

/**
 * Magic short-URL handler. Visiting `/c/:code` (e.g. /c/hl1may) saves the code
 * to localStorage so the matching promo banner is unlocked, then redirects home.
 * Used at the 1 May networking event — share `appistry.tech/c/hl1may` (or QR).
 */
export default function PromoCode() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const code = params.get("code") || (typeof window !== "undefined" ? window.location.pathname.split("/").pop() : "");

  useEffect(() => {
    if (code) {
      try { localStorage.setItem("appistry.promo", code); } catch (_) {}
      navigate(`/event/${encodeURIComponent(code)}`, { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  }, [code, navigate]);

  return (
    <div className="min-h-[40vh] flex items-center justify-center text-sm font-mono text-zinc-500" data-testid="promo-redirect">
      Unlocking your offer…
    </div>
  );
}
